import React from 'react';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';
import { getTermText } from '../../../core/Plans/utils';
import { MomentInput } from 'moment';

interface TermAmountTextProps {
  startDate: MomentInput;
  endDate: MomentInput;
  totalWages: number;
}

const TermAmountText = ({
  startDate,
  endDate,
  totalWages,
}: TermAmountTextProps) => {
  return (
    <Typography variant="body2">
      {T.translate('applicant.new.termAmountText', {
        term: getTermText({
          startDate,
          endDate,
        }),
        total: totalWages.toLocaleString(),
      })}
    </Typography>
  );
};

export default TermAmountText;
